module.exports = __webpack_public_path__ + "media/images/depositos-7b0064d14caee2b5759708cc9e0dbd38.jpg";